var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LabelComponent',{attrs:{"definition":_vm.definition,"is-locked":_vm.isLocked}}),_c('v-checkbox',{staticStyle:{"max-width":"50px"},attrs:{"dense":"","filled":"","readonly":_vm.isLocked,"input-value":_vm.data,"hide-details":"auto"},on:{"change":function($event){_vm.$emit('input', Boolean($event))}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }